import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}files/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * @returns {AxiosPromise}
   * @param dayProgramId
   */
  getItineraryDayProgramImages(dayProgramId) {
    return conduit.get(`images/day-programs/${dayProgramId}`);
  },

  /**
   * @param dayProgramId
   * @param formData
   * @returns {AxiosPromise}
   */
  uploadItineraryDayProgramImages(dayProgramId, formData) {
    return conduit.post(
      `images/day-programs/${dayProgramId}/upload`,
      formData,
      {},
      {
        'content-type': 'multipart/form-data',
      },
    );
  },

  /**
   * @param imageId
   * @returns {AxiosPromise}
   */
  deleteImage(imageId) {
    return conduit.delete(`${imageId}/delete`);
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItineraryBannerImages(itineraryId) {
    return conduit.get(`files/ItineraryBanner/${itineraryId}`);
  },

  /**
   * @param itineraryId
   * @param formData
   * @returns {AxiosPromise}
   */
  uploadItineraryBannerImages(itineraryId, formData) {
    return conduit.post(
      `files/ItineraryBanner/${itineraryId}`,
      formData,
      {},
      {
        'content-type': 'multipart/form-data',
      },
    );
  },

  /**
   * @param fileIds
   * @returns {AxiosPromise}
   */
  updateImageOrder(fileIds) {
    return conduit.put('/priorities/update', { fileIds });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItineraryMapImages(itineraryId) {
    return conduit.get(`files/itinerary-map/${itineraryId}`);
  },

  /**
   * @param itineraryId
   * @param formData
   * @returns {AxiosPromise}
   */
  uploadItineraryMapImages(itineraryId, formData) {
    return conduit.post(
      `files/itinerary-map/${itineraryId}`,
      formData,
      {},
      {
        'content-type': 'multipart/form-data',
      },
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/files-service.js